import React, { useEffect, useRef, useState } from 'react'
import "./AvaterPop.css"
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
// import assets from '../../../assets/assets'
import { IP } from "../../../internalServer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from "../../../axios"
import RemovePopUp from '../RemovePopUp'
import "../Avatar.css"


const imageNames = [
    'boy_adventure.webp',
    'boy_bookworm.webp',
    'boy_dance.webp',
    'boy_formal.webp',
    'boy_musician.webp',
    'boy_painting.webp',
    'boy_pet_lover.webp',
    'boy_scientist.webp',
    'boy_sports.webp',
    'boy_techie.webp',
    'boy_traditional_wear.webp',
    'boy_universe.webp'
];

const avatargirls = [
    'girl_bookworm.webp',
    'girl_dance.webp',
    'girl_digital.webp',
    'girl_festive_dress.webp',
    'girl_musician.webp',
    'girl_nature.webp',
    'girl_painting.webp',
    'girl_pet_lover.webp',
    'girl_scientist.webp',
    'girl_sports.webp',
    'girl_techie.webp',
    'girl_traditional_wear.webp',
]

function AvaterPop({ setClick, setGetResponse, setResMessage, handleProfileClose, setStudentDetails, studentDetails }) {
    const [selectedAvatar, setSelectedAvatar] = useState(null);
    const [avatarOnlyName, setAvatarOnlyName] = useState("")
    const [viewPopup, setViewPopup] = useState(false)
    const [removeAvatar, setRemoveAvatar] = useState(true)



    const handleAvatarClick = (avatar) => {
        // console.log("avatar", avatar)
        // console.log("removeAvatar", removeAvatar)
        if (removeAvatar === false) {
            setAvatarOnlyName("");
            // setSelectedAvatar(null)
        } else {
            const nameWithoutExtension = avatar.replace('.webp', '');
            setAvatarOnlyName(nameWithoutExtension);
            console.log("nameWithoutExtension", nameWithoutExtension)
            setSelectedAvatar(avatar);

        }

        // console.log("selectedAvatar11", selectedAvatar)

    };



    const handleSave = async () => {
        try {
            // console.log("avatarOnlyName in the api", avatarOnlyName)
            // console.log("selectedAvatarinside api", selectedAvatar)
            const response = await axios.put(`/school/student/${studentDetails.id}/avatarProfile/update`,
                {
                    avatar_profile: avatarOnlyName,
                },
            )
            if (response.status === 200) {

                const getAvatarName = response.data.data.avatar_profile;
                const existingData = localStorage.getItem('breathForStudent');
                let parsedData = existingData ? JSON.parse(existingData) : {};
                parsedData.avatar_profile = getAvatarName;
                localStorage.setItem('breathForStudent', JSON.stringify(parsedData));
                setAvatarOnlyName("");
                setSelectedAvatar(null)
                setStudentDetails((prevDetails) => ({
                    ...prevDetails,
                    avatar_profile: getAvatarName,
                }))
                setClick(false);
                setGetResponse(true)
                setResMessage({ message: "Avatar updated successfully!", status: true })
            } else {
                alert("Failed to update avatar. Please try again.");
            }
        } catch (error) {
            console.error("Error updating avatar:", error);
            if (error.response.status === 404) {
                setClick(false);
                setGetResponse(true)
                setResMessage({ message: "Failed to update avatar. Please try again.", status: false })
            }

        }
    };

    return (
        <div className="ContainerSubmitedSucess">
            <div className="SubContainerSubmitedPopupAvatar" style={{ width: "55%", position: "relative", zIndex: "-1" }}>
                <img src='./images/cross.png' alt='icon' style={{ position: "absolute", top: "-30px", left: "102%" }} onClick={() => setClick(false)} />
                <div className='main-avater-section'>
                    <h3 style={{ color: "#F77F00" }}>Select Avater Picture</h3>
                    <div className='main-avater-pic'>
                        {console.log("selectedAvatarinsideimg", selectedAvatar)}
                        <img
                            src={
                                selectedAvatar ? (studentDetails?.gender === "F" ? "/images/Girls/" : "/images/Boys/") + selectedAvatar : (
                                    studentDetails?.profile_picture
                                        ? IP + studentDetails?.profile_picture.replace(/^\./, "")
                                        : studentDetails?.gender === "M"
                                            ? studentDetails?.avatar_profile ? '/images/Boys/' + studentDetails?.avatar_profile + '.webp'
                                                : "/images/Student_boy_pic.png"
                                            : studentDetails?.gender === "F"
                                                ? studentDetails?.avatar_profile ? '/images/Girls/' + studentDetails?.avatar_profile + '.webp'
                                                    : "/images/Student_girl_pic.png"
                                                : "/images/default-profile.png"
                                )
                            }
                            alt='icon'
                            className="profilePicImg"
                            style={{ width: "130px", height: "130px", borderRadius: "50%", cursor: "pointer" }}
                            key={studentDetails?.avatar_profile}
                            onError={(e) => {
                                if (studentDetails?.gender === "M") {
                                    e.target.src = studentDetails?.avatar_profile ? '/images/Boys/' + studentDetails?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                                } else if (studentDetails?.gender === "F") {
                                    e.target.src = studentDetails?.avatar_profile ? '/images/Girls/' + studentDetails?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                                } else {
                                    e.target.src = "/images/default-profile.png"
                                }
                            }}
                        />
                    </div>
                    <div className='remove-icon' onClick={() => {
                        setViewPopup(true)
                    }} ><FontAwesomeIcon icon={faTrashCan} /> Remove Avatar </div>
                </div>
                {
                    studentDetails?.gender === "M" && <div className='child-avater-pic'>
                        {imageNames.map((avatar, index) => (
                            <img
                                key={index}
                                id="avatarImage"
                                src={`/images/Boys/${avatar}`}
                                alt={`Boy Avatar ${index + 1}`}
                                className={selectedAvatar === avatar ? "selected-avatar" : ""}
                                onClick={() => handleAvatarClick(avatar)} // Handle avatar click
                                style={{ cursor: "pointer", border: selectedAvatar === avatar ? "3px solid #F77F00" : "none", width: "80px", height: "80px" }}
                            />
                        ))}
                    </div>
                }
                {
                    studentDetails?.gender === "F" && <div className='child-avater-pic'>
                        {avatargirls.map((avatar, index) => (
                            <img
                                key={index}
                                id="avatargirls"
                                src={`/images/Girls/${avatar}`}
                                alt='avatar'
                                className={selectedAvatar === avatar ? "selected-avatar" : ""}
                                onClick={() => handleAvatarClick(avatar)} // Handle avatar click
                                style={{ cursor: "pointer", border: selectedAvatar === avatar ? "3px solid #F77F00" : "none", width: "80px", height: "80px" }}
                            />
                        ))}
                    </div>
                }
                {/* {console.log("selectedAvatar", selectedAvatar)} */}
                <div className="d-flex justify-content-around align-items-center mt-4 widthOfContainer">
                    <button
                        className={`okayBtnAvatarSuccess ${!selectedAvatar ? "disabled" : ""}`}
                        onClick={handleSave}
                        disabled={!selectedAvatar}
                    >
                        Save
                    </button>
                </div>
            </div>
            {viewPopup && <RemovePopUp setRemoveAvatar={setRemoveAvatar} setAvatarOnlyName={setAvatarOnlyName} setSelectedAvatar={setSelectedAvatar} handleSave={handleSave} setViewPopup={setViewPopup} handleProfileClose={handleProfileClose} />}
        </div>
    )
}

export default AvaterPop